import React, { useState } from 'react';
import { Settings } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import Grid from '@mui/material/Grid2';

import CheckBox from "@components/input/CheckBox";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  // show_extra_effects: boolean;
  // onShowExtraEffectsChange: (changed: boolean) => void;
  show_hidden: boolean;
  onShowHiddenChange: (changed: boolean) => void;
  show_extra_action_types: boolean;
  onShowExtraActionTypesChange: (changed: boolean) => void;
  show_rituals: boolean;
  onShowRitualsChange: (changed: boolean) => void;
  // show_disabled: boolean;
  // onShowDisabledChange: (changed: boolean) => void;
}

export default function CharacterActionsSettings({
  // show_extra_effects,
  // onShowExtraEffectsChange,
  show_hidden,
  onShowHiddenChange,
  show_extra_action_types,
  onShowExtraActionTypesChange,
  show_rituals,
  onShowRitualsChange,
  // show_disabled,
  // onShowDisabledChange
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={open}
        onClose={() => { setOpen(false) }}
      >
        <Grid container spacing={0} direction="row">
          <Grid
            className="header centered"
            size={{
              xs: 12
            }}>
            Visibility Options
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <CheckBox
              name="Show Hidden"
              value={show_hidden}
              onChange={onShowHiddenChange}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <CheckBox
              name="Show Extra Action Types"
              value={show_extra_action_types}
              onChange={onShowExtraActionTypesChange}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <CheckBox
              name="Show Rituals"
              value={show_rituals}
              onChange={onShowRitualsChange}
            />
          </Grid>
          {/* <Grid item xs={12}>
            <CheckBox
              name="Show Disabled"
              value={show_disabled}
              onChange={onShowDisabledChange}
            />
          </Grid> */}
        </Grid>
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Tooltip title={`Visibility Options`}>
        <Settings 
          className="clickable"
          style={{ color: "grey" }} 
          onClick={() => { setOpen(true); }} 
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}

